import { FC, useContext } from 'react';
import { useMount } from 'react-use';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';

import { useDictionary } from '@cvt/hooks/useDictionary';

import { TributeCardWizardContext } from '@modules/Tributes/contexts/TributeCardWizardContext';
import ImagePreviewGrid from '@modules/Tributes/components/ImagePreviewGrid';


export const SelectImageStep: FC = () => {
  const { tributeMedia, selectedImageIndex, onSelectImage, onNextStep } = useContext(TributeCardWizardContext);
  const dictionary = useDictionary();

  const handleImageSelect = (index: number) => {
    const image = tributeMedia[index];
    onSelectImage(image);
  };

  useMount(() => {
    if (tributeMedia.length === 1) {
      onSelectImage(tributeMedia[0]);
    }
  });

  return (
    <Box>
      <Stack gap={1} alignItems="center" mt={5} mb={4}>
        <Typography variant="h3" fontSize={18} fontWeight={600}>{dictionary.tributes.edit.card.cardDialog.chooseCard}</Typography>
        <Typography variant="h6" color="text.secondary" fontSize={16}>
          {dictionary.tributes.edit.card.cardDialog.chooseCardSubtitle}
        </Typography>
      </Stack>
      <Box>
        <ImagePreviewGrid
          files={tributeMedia}
          onViewMedia={handleImageSelect}
          selectedFileIndex={selectedImageIndex}
          readonly
        />
      </Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={4}
      >
        <Button
          variant="outlined"
          color="default"
          disabled
          sx={{
            px: 3,
            py: 1,
          }}
          startIcon={<ArrowBack />}
        >
            Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onNextStep}
          disabled={(selectedImageIndex ?? -1) < 0}
          sx={{
            px: 3,
            py: 1,
          }}
          endIcon={<ArrowForward />}
        >
            Next
        </Button>
      </Stack>
    </Box>
  );
};
